import * as CONF from "../constants/conf";

const normalizeText = (value) => {
    if (value === null || value === undefined) return "";
    return String(value).trim();
};

const getFirstNonEmpty = (...values) => {
    for (const value of values) {
        const normalized = normalizeText(value);
        if (normalized) return normalized;
    }

    return "";
};

export const getDeviceBusPlate = (device) => {
    return getFirstNonEmpty(
        device?.tracker_assignments?.bus?.license_plate,
        device?.tracker_assignments?.bus?.registration,
        device?.tracker_assignments?.bus?.plate,
        device?.tracker_assignments?.bus?.vehicle_registration,
        device?.bus?.license_plate,
        device?.bus?.registration,
        device?.bus?.plate,
        device?.bus?.vehicle_registration,
        device?.bus_registration,
        device?.license_plate,
        device?.plate,
        device?.vehicle_registration,
        device?.tracker_operational_gis?.bus?.license_plate,
        device?.tracker_operational_gis?.bus?.registration,
        device?.tracker_operational_gis?.bus?.plate,
        device?.tracker_operational_gis?.bus?.vehicle_registration
    );
};

export const getDeviceDisplayName = (device) => {
    const busNumber = getFirstNonEmpty(
        device?.bus_number,
        device?.busNumber
    );

    const plate = getDeviceBusPlate(device);

    return getFirstNonEmpty(
        busNumber ? `Bus ${busNumber}` : "",
        plate,
        device?.name,
        device?.device_name,
        device?.serial,
        device?.serial_number
    );
};

export const getDeviceDisplayNameForInfo = (device) => {
    if(device?.program_type == CONF.DEVICE_PROGRAM_TYPE_EMT) {
        var busNumber = device.tracker_assignments?.bus?.bus_number;
        return device.bus_id !== null ? `Bus ${busNumber}` : device.name;
    } else {
        return device.name; 
    }
};